<div
  [class.feedback-message-warning]="type() === 'warning'"
  [class.feedback-message-invalid]="type() === 'invalid'"
  [class.size-x-small]="size() === 'x-small'"
>
  <span class="d-flex align-items-start gap-1">
    <lib-icon
      [name]="type() === 'warning' ? 'alert-triangle' : 'x-circle'"
      aria-hidden="true"
      [size]="size()"
    ></lib-icon>
    <span><ng-content></ng-content></span>
  </span>
</div>
